import { MandatesListType } from '../models';

export const isMandateListActive = (type: MandatesListType) =>
  type === 'Active';

// Mandate self-service
export const isCompanyStep = (step: number) => step === 0;
export const isSignatoriesStep = (step: number) => step === 1;
export const isProductAreasStep = (step: number) => step === 2;
